<template>
	<div class="box vh-140">
		<div class="box-header">
			<h3 class="box-title"><i class="fa fa-th-large"></i> 机构列表</h3>
			<div class="box-tools">
				<el-button size="small" class="pull-right" type="primary" @click="toEditUnit()" round><i class="fa fa-plus"></i> 添加机构</el-button>
			</div>
		</div>
		<div class="box-body">


			<el-table ref="multipleTable" :data="unitList" stripe border tooltip-effect="dark" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
				<template slot="empty">
					<div class="no-data">暂无数据！</div>
				</template>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" label="名称" width="250" :formatter="formatTab"></el-table-column>
				<el-table-column prop="type" label="类别" width="120" :formatter="formatType"></el-table-column>
				<el-table-column prop="userName" label="负责人" width="120"></el-table-column>
				<el-table-column prop="weight" label="权重" width="240"></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="100">
					<template slot-scope="scope">
						<el-button @click="toEditUnit(scope.row.id)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
						<el-button @click="deleteUnit(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

    <el-dialog :title="isEdit ? '编辑' : '添加'" :visible.sync="dialogVisible" width="480px" class="form-dialog">
      <el-form :model="form" ref="form" size="small" center label-width="90px" :rules="rules">
        <el-form-item label="上级" prop="parentId">
          <el-cascader :options="options" v-model="parentIdEcho" change-on-select :props="props" style="width: 70%"></el-cascader>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入机构名称" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">集团</el-radio>
            <el-radio :label="2">公司</el-radio>
            <el-radio :label="3">部门</el-radio>
            <el-radio :label="4">小组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="负责人" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入机构负责人" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input v-model="form.weight" placeholder="请输入权重" style="width: 70%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
          <el-button @click="dialogVisible = false" size="small" round><i class="fa fa-close"></i> 取 消</el-button>
          <el-button type="primary" @click="saveUnit" size="small" round><i class="fa fa-save"></i> 确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import { fetchList, get, save, update, remove, tree } from '@/api/system/unit'
import { handleConfirm } from '@utils/confirm'

export default {
	created() {
		this.fetchData()
	},
	methods: {
		formatTab(row, column, val) {
			let prefix = []
			if (row.parentIds && row.parentIds !== '0') {
				let preLength = row.parentIds.split(',').length
				prefix = Array(preLength === 0 ? 1 : preLength).fill('　')
			}
			return prefix.join('') + '├ ' + val
		},
		formatType: function(row, column, val) {
			return val === 1 ? '集团' : val === 2 ? '公司' : val === 3 ? '部门' : val === 4 ? '小组' : ''
		},
		fetchData() {
			fetchList().then(resp => {
				this.unitList = resp.data.result
			})
		},
		saveUnit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.form.parentId = this.parentIdEcho[this.parentIdEcho.length - 1]
					this.form.parentIds = this.parentIdEcho.join(',')

					if (this.isEdit) {
						update(this.form).then(resp => {
							this.submitCallback(resp)
						})
					} else {
						save(this.form).then(resp => {
							this.submitCallback(resp)
						})
					}
				}
			})
		},
		submitCallback(resp) {
			if (resp.status === 200) {
				this.dialogVisible = false
				this.fetchData()
				this.$message.success(resp.data.message)
			}
		},
		deleteUnit(val) {
      handleConfirm('此操作将永久删除此机构, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.submitCallback(resp)
        })
      })
		},
		toEditUnit(val) {
			this.getEcho()
			this.dialogVisible = true
			if (val) {
				this.isEdit = true
				get(val).then(resp => {
					this.form = resp.data.result
					this.parentIdEcho = this.form.parentIds.split(',').map(h => {
						return +h
					})
				})
			} else {
				this.isEdit = false
				this.form = { type: 1 }
				this.parentIdEcho = [0]
			}
		},
		getEcho() {
			tree().then(resp => {
				this.options = resp.data.result
				this.options.push({ name: '根节点', id: 0 })
			})
		}
	},
	data: function() {
		return {
			options: [],
			props: {
				value: 'id',
				label: 'name',
				children: 'childrens'
			},
			form: {},
			rules: {
				name: [
					{ required: true, message: '请输入机构名称', trigger: 'blur' },
					{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
				]
			},
			parentIdEcho: [0],
			dialogVisible: false,
			isEdit: false,
			unitList: []
		}
	}
}
</script>
